import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { environment as ENV } from "@environments/environment";
import { SSOService } from "@core/services/sso.service";

// Guards
import { AuthenticationGuard } from "@core/guards";
import { PermissionGuard } from "@core/guards/permission.guard";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("@app/modules/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "logout",
    loadChildren: () =>
      import("@app/modules/logout/logout.module").then((m) => m.LogoutModule),
  },
  {
    path: "dashboard",
    data: {
      roles: [],
    },
    loadChildren: () =>
      import("@app/modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthenticationGuard, PermissionGuard],
  },
  {
    path: "self-onboarding",
    loadChildren: () =>
      import(
        "@app/modules/vendors/self-onboarding/self-onboarding.module"
      ).then((m) => m.SelfOnboardingModule),
    canActivate: [AuthenticationGuard],
  },
  { path: "**", redirectTo: "dashboard", pathMatch: "full" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: ENV.route_hash,
      anchorScrolling: "enabled",
    }),
  ],
  providers: [SSOService],
  exports: [RouterModule],
})
export class AppRoutingModule {}
